<template>
  <div class="horizontal layout center">
    <Buttonv2
      variant="no-border"
      size="lg"
      @click="fbShareLink()"
      class="flex mr-1 facebook-button"
    >
      <span class="d-sm-none d-md-block">
        <i class="fab fa-facebook-f" /> Facebook
      </span>
      <span class="text-sm d-none d-sm-block d-md-none">
        <i class="fab fa-facebook-f" />
        Facebook
      </span>
    </Buttonv2>

    <Buttonv2
      variant="no-border"
      size="lg"
      class="flex ml-1 twitter-button"
      @click="twShareLink()"
    >
      <span class="d-sm-none d-md-block">
        <i class="fab fa-twitter" /> Twitter
      </span>
      <span class="text-sm d-none d-sm-block d-md-none">
        <i class="fab fa-twitter" />
        Twitter
      </span>
    </Buttonv2>
    <!-- <a @click="fbShareLink()" class="flex mr-1">
      <button class="ui-button--block ui-button--lg ui-button--outline-dark">
        <span class="text-base d-sm-none d-md-block">
          <i class="fab fa-facebook-square" />
          {{ $t('Post to {msg}', { msg: 'Facebook' }) }}
        </span>
        <span class="text-base d-none d-sm-block d-md-none">
          <i class="fab fa-facebook-square" />
          Facebook
        </span>
      </button>
    </a>

    <a
      class="flex ml-1"
      @click="twShareLink()"
    >
      <button class="ui-button--block ui-button--lg ui-button--outline-dark">
        <span class="text-base d-sm-none d-md-block">
          <i class="fab fa-twitter" />
          {{ $t('Post to {msg}', { msg: 'Twitter' }) }}
        </span>
        <span class="text-base d-none d-sm-block d-md-none">
          <i class="fab fa-twitter" />
          Twitter
        </span>
      </button>
    </a> -->
  </div>
</template>

<script>
import Config from '@/config'
import Util from '@/util'
import Buttonv2 from '@/components/UI/Buttonv2.vue'

export default {
  components: {
    Buttonv2,
  },
  props: {
    correctRate: Number,
    percentile: Number,
    position: Number,
    total: Number,
    isTeam: Boolean,
    shareType: String,
    presenterName: String,
    presentationName: String,
  },

  methods: {
    buildUrl(url, params) {
      const query = Object.entries(params)
        .map((pair) => pair.map(encodeURIComponent).join('='))
        .join('&')
      return `${url}${query ? `?${query}` : ''}`
    },

    encodeResult() {
      const rawData = [
        this.position,
        this.correctRate,
        this.percentile,
        this.total,
      ]
      // Base64 encode the data to pass to query string
      // To prevent modification on the url -> audience can cheat the share badge
      return Util.toBinary(JSON.stringify(rawData))
    },
    getShareLink(source) {
      const presentationId = this.$store.state.presentation.id
      const shareRoot = `${Config.baseUrl}/p/quiz/${this.shareType}`

      const queryStr = {
        utm_campaign: 'share_quiz_result',
        utm_medium: 'share',
        utm_source: source,
        utm_content: `quiz_result_presentation_${presentationId}`,
        lang: this.$store.state.presentation.language || 'en',
        i: +this.isTeam,
        pt: this.presenterName,
        ps: this.presentationName,
        k: this.encodeResult(),
      }

      // en is default
      if (queryStr.lang === 'en') {
        delete queryStr.lang
      }

      return encodeURIComponent(this.buildUrl(shareRoot, queryStr))
    },
    fbShareLink() {
      const presentationId = this.$store.state.presentation.id
      const href = this.getShareLink('facebook')
      const redirectUri = encodeURIComponent('https://www.facebook.com')
      const appId = 938819863278189

      Util.gaTrackEvent(
        'Audience Quiz',
        'Share quiz result to Facebook',
        `Share quiz result to Facebook for presentation ${presentationId}, type ${this.shareType}`,
      )

      const link = `https://www.facebook.com/dialog/share?app_id=${appId}&display=popup&href=${href}&redirect_uri=${redirectUri}`
      window.open(link, '_blank')
    },
    twShareLink() {
      const presentationId = this.$store.state.presentation.id
      const href = this.getShareLink('twitter')
      const sharingText = this.$t('I just finished a super fun quiz on AhaSlides')
      const text = encodeURIComponent(`${sharingText.replace(' AhaSlides', ' @AhaSlides')} #ahaslides`)

      Util.gaTrackEvent(
        'Audience Quiz',
        'Share quiz result to Twitter',
        `Share quiz result to Twitter for presentation ${presentationId}, type ${this.shareType}`,
      )

      const link = `https://twitter.com/intent/tweet?text=${text}&url=${href}`
      window.open(link, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
$facebook-color: #2A5297;
$twitter-color: #55ADED;
.ui-button--block {
  height: 42px;
  padding: 0 16px;
  border-radius: 20px;
}

.fa-twitter {
  color: $twitter-color;
  margin-right: 2px;
  transition: color 0.3s ease-in-out;
}

.fa-facebook-f {
  color: $facebook-color;
  margin-right: 2px;
  transition: color 0.3s ease-in-out;
}

.facebook-button {
  background: $facebook-color;
  color: #fff;
  .fa-facebook-f {
    color: #fff;
  }
  &:hover, &:active, &:focus {
    background: darken($facebook-color, 10%);
  }
}

.twitter-button {
  background: $twitter-color;
  color: #fff;
  .fa-twitter {
    color: #fff;
  }
  &:hover, &:active, &:focus {
    background: darken($twitter-color, 10%);
  }
}
@media (max-width: 350px) {
  .text-base {
    font-size: 14px;
  }
}
</style>
